<template>
  <div class="wrapper">

    <div class="row">
      <div class="col-12">
        <h3>{{ course.title }}</h3>
      </div>
    </div>

    <form action="#">

      <!-- User: -->
      <div class="form-section">
        <div class="row">
          <v-input v-model="user.vorname" name="user.vorname" label="Vorname(n)" :required="true"></v-input>
          <v-input v-model="user.nachname" name="user.nachname" label="Nachname" :required="true"></v-input>
        </div>

        <div class="row">
          <v-input v-model="user.email" name="user.email" label="E-mail" type="email" :required="true"></v-input>
          <v-input v-model="user.phone" name="user.phone" label="Telefonnummer" :required="true"></v-input>
        </div>

        <div class="row">
          <v-input v-model="user.company" name="user.company" label="Organisation"></v-input>
          <v-input v-model="user.position" name="user.position" label="Position"></v-input>
        </div>
      </div>

      <!-- Options.package: -->
      <div class="form-section">
        <div class="row">
          <div class="col-12">
            <div class="input-wrapper" :class="{error: form.errors.has('options.package')}">
              <div class="form-label">ICH NEHME AN DER GESAMTEN VERANSTALTUNG TEIL.*</div>

              <v-radio @input="val => options.package = val" styleclass="inline-elements" name="options.package" type="radio" label="Ja." value="1"></v-radio>
              <v-radio @input="val => options.package = val" styleclass="inline-elements" name="options.package" type="radio" label="Nein." value="0"></v-radio>
              <span v-if="form.errors.has('options.package')" class="error-msg">{{ form.errors.get('options.package') }}</span>
            </div>
          </div>
        </div>
      </div>

        <!-- Options.tagen -->
        <template v-if="options.package === '0'">
          <div v-bind:class="{ deactivated: showAdditionalFields  }" class="form-section">
            <div class="row">
              <div class="col-12">
                <div class="input-wrapper inline-elements" :class="{error: form.errors.has('options.tagen')}">
                  <div class="form-label">ICH NEHME NUR AN FOLGENDEN TAGEN TEIL:*</div>

                    <div v-for="day in termine.days" :key="day.id" class="input-single inline-elements">
                      <label class="radio-label">
                        <input v-model="options.tagen" type="checkbox" :value="day.id" :disabled="showAdditionalFields">
                        {{day.date}}
                        <span class="checkmark"></span>
                      </label>
                    </div>
                    <span v-if="form.errors.has('options.tagen')" class="error-msg">{{ form.errors.get('options.tagen') }}</span>

                </div>
              </div>
            </div>
          </div>
        </template>

        <!-- Options.shuttle -->
        <div class="form-section">
          <div class="row">
            <div class="col-12">
              <div class="input-wrapper" :class="{error: form.errors.has('options.shuttle')}">
                <div class="form-label">ICH MöCHTE DEN SHUTTLE-SERVICE IN ANSPRUCH NEHMEN.*</div>
                <v-radio @input="val => options.shuttle = val" styleclass="" name="options.shuttle" type="radio" label="Ja, Hin- und Rückfahrt." value="1"></v-radio>
                <v-radio @input="val => options.shuttle = val" styleclass="" name="options.shuttle" type="radio" label="Ja, nur Hinfahrt." value="2"></v-radio>
                <v-radio @input="val => options.shuttle = val" styleclass="" name="options.shuttle" type="radio" label="Ja, nur Rückfahrt." value="3"></v-radio>
                <v-radio @input="val => options.shuttle = val" styleclass="" name="options.shuttle" type="radio" label="Nein, ich reise selbst an/ab." value="4"></v-radio>
                <span v-if="form.errors.has('options.shuttle')" class="error-msg">{{ form.errors.get('options.shuttle') }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Options.nutrition -->
        <div class="form-section">
          <div class="row">
            <v-input v-model="options.nutrition" name="options.nutrition" label="Ich habe folgende Ernärungsbedürfnisse:"></v-input>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <br>
            <hr>
            <br>
          </div>
        </div>

        <!-- Options.childcare -->
        <div class="form-section">
          <div class="row">
            <div class="col-12">
              <div class="input-wrapper inline-elements">
                <div class="form-label">ICH KOMME MIT KIND/ERN UND ERSUCHE UM INFORMATIONEN ZUR KINDERBETREUUNG.*</div>
                <v-radio @input="val => options.childcare = val" styleclass="inline-elements" name="options.childcare" type="radio" label="Ja." value="1"></v-radio>
                <v-radio @input="val => options.childcare = val" styleclass="inline-elements" name="options.childcare" type="radio" label="Nein." value="0"></v-radio>
                <span v-if="form.errors.has('options.childcare')" class="error-msg">{{ form.errors.get('options.childcare') }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Options.camping -->
        <div class="form-section">
          <div class="row">
            <div class="col-12">
              <div class="input-wrapper inline-elements">
                <div class="form-label">ICH KOMME MIT EIGENEM ZELT UND ERSUCHE UM INFORMATIONEN ZUR CAMPINGWIESE.*</div>
                <v-radio @input="val => options.camping = val" styleclass="inline-elements" name="options.camping" type="radio" label="Ja." value="1"></v-radio>
                <v-radio @input="val => options.camping = val" styleclass="inline-elements" name="options.camping" type="radio" label="Nein." value="0"></v-radio>
                <span v-if="form.errors.has('options.camping')" class="error-msg">{{ form.errors.get('options.camping') }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Options.culturePass -->
        <div class="form-section">
          <div class="row">
            <div class="col-12">
              <div class="input-wrapper inline-elements">
                <div class="form-label">ICH NEHME ALS KULTURPASSINHABER*IN AN DER SOMMERAKADEMIE TEIL.*</div>
                <v-radio @input="val => options.culturePass = val" styleclass="inline-elements" name="options.culturePass" type="radio" label="Ja." value="1"></v-radio>
                <v-radio @input="val => options.culturePass = val" styleclass="inline-elements" name="options.culturePass" type="radio" label="Nein." value="0"></v-radio>
                <span v-if="form.errors.has('options.culturePass')" class="error-msg">{{ form.errors.get('options.culturePass') }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <br>
            <hr>
          </div>
        </div>

      <!-- GDPR -->
      <div class="form-section">
        <div class="row">
          <div class="col-12">
            <div class="input-wrapper">
              <v-checkbox v-model="user.gdprnews" name="user.gdprnews" label="Ich möchte ASPR NEWS und relevante
                  Informationen über ASPR Veranstaltungen erhalten und bin mit einer diesbezüglichen Speicherung meiner
                  Daten nach Richtlinien der Europäischen Datenschutzgrundverordnung einverstanden. Meine Einwillingung
                  kann ich jederzeit widerrufen." :required="false"></v-checkbox>
            </div>
          </div>

          <div class="col-12">
            <div class="input-wrapper">
              <v-checkbox v-model="user.gdprstorno" name="user.gdprstorno" label="Ich akzeptiere die
                  <a href='/geschaefts-und-stornobedingungen/' target='_blank' rel='noopener'>
                  Geschäfts- und Stornobedingungen</a>" :required="true"></v-checkbox>
            </div>
          </div>

          <div class="col-12">
            <div class="input-wrapper">
              <v-checkbox v-model="user.gdprdaten" name="user.gdprdaten" label="Ich bin mit der Speicherung meiner persönlichen Daten
                  für den Zweck der Abwicklung der Veranstaltung nach Richtlinien der Europäischen
                  <a href='/datenschutz/' target='_blank' rel='noopener'>Datenschutzgrundverordnung</a> einverstanden.
                  " :required="true"></v-checkbox>
            </div>
          </div>
        </div>

      </div>

      <!-- Submit: -->
      <div class="row">
        <div class="col-lg-3 col-md-4 col-12">
          <div class="input-wrapper">
            <button @click.prevent="submit" class="btn-submit" style="display:flex">
              <span>Anmelden</span>
              <span class="arrow"></span>
            </button>
          </div>
        </div>
      </div>

    </form>

  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import VInput from './fields/VInput'
import VCheckbox from './fields/VCheckbox'
import VRadio from './fields/VRadio'

const { mapState, mapActions, mapGetters } = createNamespacedHelpers('form')

export default {
  name: 'Form',
  components: {
    VInput,
    VCheckbox,
    VRadio
  },

  data () {
    return {
      user: {
        vorname: '',
        nachname: '',
        email: '',
        phone: '',
        company: '',
        position: '',
        gdprnews: '',
        gdprstorno: '',
        gdprdaten: ''
      },
      options: {
        tagen: [],
        package: null,
        shuttle: null,
        childcare: null,
        camping: null,
        culturePass: null,
        nutrition: ''
      }
    }
  },

  computed: {
    ...mapGetters(['showAdditionalFields']),
    ...mapState(['form', 'termine', 'course']),
    selectedPackage () {
      return this.options.package
    }
  },

  created () {
    this.fetchCourse()
  },

  methods: {
    ...mapActions(['updateUser', 'updateOptions', 'sendForm', 'fetchCourse']),
    async submit () {
      var response = await this.sendForm()
      response.success && this.$router.push('thankyou')
    }
  },

  watch: {
    user: {
      handler: function (val) {
        this.updateUser({
          user: val
        })
      },
      deep: true
    },
    options: {
      handler: function (val) {
        this.updateOptions({
          options: val
        })
      },
      deep: true
    },
    selectedPackage: {
      handler: function (val) {
        this.$nextTick(() => {
          const tagen = this.termine.days.map(day => day.id)
          this.options.tagen = (val === '1') ? tagen : []
        })
      }
    }
  }

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .input-wrapper {
        &.error {
            input {
                border-color: #c2063b;
            }
        }

        .error-msg {
            color: #c2063b;
            font-size: 15px;
            display: block;
        }
    }
</style>
